import '../style/StatsStrip.css';
import { useEffect, useMemo, useRef, useState } from 'react';

const stats = [
  { value: '1000+', label: 'Container Shipped' },
  { value: '100+', label: 'Happy Clients' },
  { value: '8+', label: 'Destinations' },
  { value: '900+', label: 'Tons Per Month' },
];

function parseValue(value) {
  const numeric = Number.parseInt(value.replace(/[^\d]/g, ''), 10);
  return Number.isNaN(numeric) ? 0 : numeric;
}

export default function StatsStrip() {
  const sectionRef = useRef(null);
  const [hasStarted, setHasStarted] = useState(false);
  const [counts, setCounts] = useState(() => stats.map(() => 0));
  const targets = useMemo(() => stats.map((item) => parseValue(item.value)), []);

  useEffect(() => {
    if (hasStarted) return undefined;
    const el = sectionRef.current;
    if (!el) return undefined;

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setHasStarted(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        if (isVisible) {
          setHasStarted(true);
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [hasStarted]);

  useEffect(() => {
    if (!hasStarted || typeof window === 'undefined') return undefined;

    const duration = 1500;
    const start = performance.now();
    let rafId;

    const tick = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);

      setCounts(targets.map((target) => Math.round(target * eased)));

      if (progress < 1) {
        rafId = window.requestAnimationFrame(tick);
      }
    };

    rafId = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(rafId);
  }, [hasStarted, targets]);

  return (
    <section className="StatsStrip" aria-label="Company statistics" ref={sectionRef}>
      <div className="StatsStrip-inner">
        {stats.map((item, idx) => (
          <div key={item.label} className="StatsStrip-item">
            <span className="StatsStrip-value">{`${counts[idx]}+`}</span>
            <span className="StatsStrip-label">{item.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
